import { Badge } from '@/components/ui/badge';
import { Datum } from '@/domain/navigation/benachrichtigungen/components/details/shared/Datum';
import { DetailWrapper } from '@/domain/navigation/benachrichtigungen/components/details/shared/DetailWrapper';
import { Krankmeldungen } from '@/domain/navigation/benachrichtigungen/types/Krankmeldungen';
import { managerV1BaseUrl } from '@/utils';
import {
  faPersonPregnant,
  faSuitcaseMedical,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export default function KrankmeldungenDetail({
  benachrichtigung,
}: {
  benachrichtigung: Krankmeldungen;
}) {
  const { t } = useTranslation();

  const linkTo = `${managerV1BaseUrl}/secure/krankmeldung/index.jsf`;

  return (
    <a href={linkTo}>
      <DetailWrapper
        mitarbeiter={benachrichtigung.mitarbeiter}
        content={
          <>
            <Badge className="rounded-full w-fit bg-secondary-cyan-500 hover:bg-secondary-cyan-500 text-xs">
              {benachrichtigung.istKindkrank ? (
                <>
                  <FontAwesomeIcon
                    className="text-xs max-h-3 max-w-3 overflow-hidden"
                    icon={faPersonPregnant}
                  />
                  {t(
                    'domain.navigation.benachrichtigungen.krankmeldungen.kindkrank',
                  )}
                </>
              ) : (
                <>
                  <FontAwesomeIcon
                    className="text-xs max-h-3 max-w-3 overflow-hidden"
                    icon={faSuitcaseMedical}
                  />
                  {t(
                    'domain.navigation.benachrichtigungen.krankmeldungen.krankheitsTag',
                  )}
                </>
              )}
            </Badge>
          </>
        }
        footer={
          <Datum
            von={benachrichtigung.voraussichtlichVon}
            bis={benachrichtigung.voraussichtlichBis}
          />
        }
      />
    </a>
  );
}
